import type { NavigateFunction, To } from 'react-router-dom'

type ViewTransitionDocument = Document & {
  startViewTransition?: (callback: () => void) => void
}

export const navigateWithPageTransition = (
  navigate: NavigateFunction,
  to: To
) => {
  const transitionDocument = document as ViewTransitionDocument

  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    typeof transitionDocument.startViewTransition !== 'function'
  ) {
    navigate(to)
    return
  }

  transitionDocument.startViewTransition(() => {
    navigate(to)
  })
}
